import CreateForwardingDirectiveEntryForm from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryForm'
import CreateMaintenanceForwardingDirectiveError from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateMaintenanceForwardingDirectiveError'
import CreateMaintenanceForwardingDirectiveLoading from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateMaintenanceForwardingDirectiveLoading'
import CreateMaintenanceForwardingSelectDirectiveEntry from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateMaintenanceForwardingSelectDirectiveEntry'
import { useMaintenanceForwardingsShowDirectiveDetails } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/hooks/useMaintenanceForwardingsShowDirectiveDetails'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const CompanyMaintenanceWorkflowsForwardingsCreate = () => {
  const { id: workflowId, directiveEntryType } = useParams()

  const { initForm } = useCreateForwardingsFormStore()

  const {
    data: directiveDetails,
    isPending: directiveDetailsIsPending,
    isError: directiveDetailsIsError,
    error: directiveDetailsError = {} as any,
    refetch: refetchDirectiveDetails,
  } = useMaintenanceForwardingsShowDirectiveDetails({
    workflowId,
    directiveEntryKlass: directiveEntryType,
  })

  useEffect(initForm, [])

  if (!directiveEntryType) {
    return <CreateMaintenanceForwardingSelectDirectiveEntry />
  }

  if (directiveDetailsIsPending) {
    return <CreateMaintenanceForwardingDirectiveLoading />
  }

  if (directiveDetailsIsError) {
    return (
      <CreateMaintenanceForwardingDirectiveError
        statusCode={directiveDetailsError?.status}
        refetchFunction={refetchDirectiveDetails}
        message={directiveDetailsError?.response?.data?.errors?.base?.[0]}
      />
    )
  }

  return <CreateForwardingDirectiveEntryForm directiveDetails={directiveDetails} />
}

export default CompanyMaintenanceWorkflowsForwardingsCreate
